/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import { SET_POSTS_COUNT, SET_THREAD_NAME, SET_COMMENTS_COUNT } from '@/store/actions/threadInfo';

const state = {
  threadFeedsCount: '',
  threadFeedsCommentsCount: '',
  threadName: '',
};

const getters = {};

const actions = {
  [SET_POSTS_COUNT]: ({ commit }, count) => {
    commit(SET_POSTS_COUNT, count);
  },
  [SET_THREAD_NAME]: ({ commit }, name) => {
    commit(SET_THREAD_NAME, name);
  },
  [SET_COMMENTS_COUNT]: ({ commit }, count) => {
    commit(SET_COMMENTS_COUNT, count);
  },
};

const mutations = {
  [SET_POSTS_COUNT]: (state, count) => {
    state.threadFeedsCount = count;
  },
  [SET_THREAD_NAME]: (state, name) => {
    state.threadName = name;
  },
  [SET_COMMENTS_COUNT]: (state, count) => {
    state.threadFeedsCommentsCount = count;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
